<link *ngIf="themeUrl" rel="stylesheet" [href]="themeUrl" />

<ngx-loading-bar height="6px" khA11yAlert="status"></ngx-loading-bar>

<div *ngIf="translationsLoading$ | async as loading">
  <div class="animated-loading-logo" *ngIf="loading" khA11yAlert="status">
    <img src="images/Logo-Animated.gif" />
  </div>
</div>

<router-outlet></router-outlet>

<!-- Cookie Consent Banner -->
<kh-cookie-consent-banner></kh-cookie-consent-banner>